import { AccordionData } from '../../../../../../../components/Accordion/Accordion';
import { StepsNavigationName } from '../../../../../../../config/services';
import { formatDate } from '../../../../../../../helpers/dates';
import { parseFormDataValue } from '../../../../../../../helpers/parseFormDataValue';
import { NullValueGuard } from '../../../../../../../middlewares/NullValueGuard';

import { PermitDataFieldName, PermitFormDataProps } from './types';

interface PreviewProps {
  formData: PermitFormDataProps;
  permitTypeLabel: string;
}
export const previewPermitData = ({ formData, permitTypeLabel }: PreviewProps): AccordionData => {
  return {
    title: StepsNavigationName.permissionData,
    content: (
      <div className="custom-columns custom-columns_grey-bg custom-columns_default-gap">
        <div className="custom-columns__row custom-columns__row_padding-tiny custom-columns__row_one-col">
          <div className="custom-columns__col">
            <div className="custom-columns__title">Тип дозволу</div>
            <div className="custom-columns__info">{permitTypeLabel}</div>
          </div>
        </div>
        <div className="custom-columns__row custom-columns__row_padding-tiny">
          <div className="custom-columns__col">
            <div className="custom-columns__title">Номер дозволу</div>
            <div className="custom-columns__info">
              <NullValueGuard>{parseFormDataValue(formData[PermitDataFieldName.permitType])?.num}</NullValueGuard>
            </div>
          </div>
          <div className="custom-columns__col">
            <div className="custom-columns__title">Дата видачі</div>
            <div className="custom-columns__info">
              <NullValueGuard>
                {formatDate(parseFormDataValue(formData[PermitDataFieldName.permitType])?.issuedAt ?? '')}
              </NullValueGuard>
            </div>
          </div>
          <div className="custom-columns__col">
            <div className="custom-columns__title">Термін дії</div>
            <div className="custom-columns__info">
              <NullValueGuard>
                {formatDate(parseFormDataValue(formData[PermitDataFieldName.permitType])?.expiredAt ?? '')}
              </NullValueGuard>
            </div>
          </div>
        </div>
      </div>
    ),
  };
};
